import { useState, useEffect, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { getCurrencySymbolSafe } from '../helpers/currency';

export default function InstallmentsDropdown({ options, selected, onSelect, label = null, i18nKey = null, labelEntry = null, labelFor = null, fieldClassName = 'field' }) {
  const { t, tMixed, tBackend } = useTranslation();
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  if (!options || options.length === 0) {
    return null;
  }

  const renderBadge = (opt) => (
    opt.installments != "0" &&
    <div className={"installment-description installment-badge" + (opt.interest ? " installment-badge-con" : " installment-with-interest installment-badge-sin")}>
      {opt.interest ? t('installments.with_interest') : t('installments.without_interest')}
    </div>
  );

  const resolveOptionLabel = (opt) => {
    if (!opt) return '';
    if ("i18nContent" in opt) return tMixed(opt.i18nContent);
    if (opt.installment_amount != null && opt.installments != null) {
      const symbol = getCurrencySymbolSafe(opt.currency);
      return `${opt.installments}x ${symbol} ${opt.installment_amount}`.replace(/\s+/g, ' ').trim();
    }
    return opt.label;
  };

  const hasValue = Boolean(selected);

  return (
    <div className={fieldClassName + (open ? " open" : "") + (hasValue ? " has-value" : "")} ref={containerRef}>
      {/* labelEntry (backend {content,i18nContent}) tiene prioridad; si no, label/i18nKey legacy (tarjeta) */}
      {labelEntry
        ? <label htmlFor={labelFor}>{tBackend(labelEntry)}</label>
        : (label && <label htmlFor={labelFor}>{i18nKey ? t(i18nKey) : label}</label>)}
      <div
        className={"installments-select" + (open ? " open" : "")}
        role="button"
        tabIndex={0}
        onClick={() => setOpen(o => !o)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(o => !o); } }}
      >
        {selected && (
          <div className={"installment-wrap"}>
            <div className={"installment-element installment-label"}>{resolveOptionLabel(selected)}</div>
            <div className={"installment-element installment-detail"}>{renderBadge(selected)}</div>
          </div>
        )}
        <span className={"installments-select-handle"} aria-hidden="true" />
      </div>
      {open && (
        <div className={"installments-dropdown"} role="listbox">
          {options.map((opt) => (
            <div
              key={opt.random_key}
              className={"installment-item-wrap"}
              role="option"
              aria-selected={selected && selected.installments === opt.installments}
              onClick={() => { onSelect(opt); setOpen(false); }}
            >
              <div className={"installment-element installment-label"}>{resolveOptionLabel(opt)}</div>
              <div className={"installment-element installment-detail"}>{renderBadge(opt)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
